/* eslint-disable */
<template>
  <div class="container-fluid mtb15 no-fluid">
    <div class="row sm-gutters">
      <!-- Menu -->
      <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2 wallet-menu-column">
        <AppMenu></AppMenu>
      </div>
      <!-- Modal trade confirmed -->
      <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="tradeConfirmedLabel" :aria-hidden="!tradeConfirmedModalActive"
        :class="{ 'show': tradeConfirmedModalShow, 'd-block': tradeConfirmedModalActive }">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header trade-confirmed-modal-header">
              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"
                @click="closeTradeConfirmedModal"></button>
            </div>
            <div class="modal-body">
              <TradeConfirmed :order="orderModel" />
            </div>
          </div>
        </div>
      </div>
      <!-- Modal confirm order cancel -->
      <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirmDeleteLabel" :aria-hidden="!cancelOrderModalActive"
        :class="{ 'show': cancelOrderModalShow, 'd-block': cancelOrderModalActive }">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="confirmDeleteLabel">{{ t("confirmCancelOrderLabel") }}</h5>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal"
                @click="confirmAndCloseCancelOrderModal">{{
                t("confirmLabel")
                }}</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal"
                @click="closeCancelOrderModal">{{
                t("closeLabel")
                }}</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="cancelOrderModalActive" class="modal-backdrop fade show"></div>
      <!-- Modal order update -->
      <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="confirmDeleteLabel" :aria-hidden="!editOrderModalActive"
        :class="{ 'show': editOrderModalShow, 'd-block': editOrderModalActive }">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body">
              <Trading :id="$store.getters['getSelectedTradingStockName']"></Trading>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal"
                @click="closeEditOrderModal">{{
                t("closeLabel")
                }}</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="editOrderModalActive" class="modal-backdrop fade show"></div>
      <!-- Wallet -->
      <div class="col-sm-12" :class="{ 'col-md-10' :  1200 < getWindowsWidth }">
        <div class="settings mtb15">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-2">
                <WalletTabs
                  :active-menu-selection="activeMenuSelection"
                  :labels="walletTabLabels"
                  :user-type="getUserType()"
                  :window-width="getWindowsWidth"
                  @select="selectWalletTab"
                />
              </div>
              <div class="col-lg-10">
                <div class="tab-content" id="myTabContent">
                  <WalletSummary
                    :active-menu-selection="activeMenuSelection"
                    :translator="t"
                    :price-formatter="formatPrice"
                    :number-parser="parseNumber"
                    :money-ratio-resolver="getMoneyRatio"
                    :total-money-percent-resolver="getCurrencyAsPercentFromTotalMoney"
                    :total-balance-percent-resolver="getCurrencyAsPercentFromTotalBalance"
                    :settlement-resolver="getCurrencySettlementAmounts"
                    :open-breakdown="openWalletBreakdownByExchange"
                    :open-instrument-type-breakdown="openWalletBreakdownByInstrumentType"
                    :summary="walletSummaryData"
                  />
                  <WalletTransactionsTab
                    v-model:filter-selected-date="filterSelectedDate"
                    v-model:filter-transactions-by-type="filterTransactionsByType"
                    v-model:filter-transactions-by-currency="filterTransactionsByCurrency"
                    v-model:filter-transactions-by-amount="filterTransactionsByAmount"
                    v-model:filter-transactions-by-period="filterTransactionsByPeriod"
                    v-model:sort-transactions="sortTransactions"
                    v-model:show-transaction-filters="showTransactionFilters"
                    v-model:show-transaction-sorting="showTransactionSorting"
                    :active-menu-selection="activeMenuSelection"
                    :transactions="getAvailableTransactions"
                    :loading="walletDataLoading && 'Transactions' === activeMenuSelection"
                    :windows-width="getWindowsWidth"
                    :min-date-for-wallet="minDateForWallet"
                    :translator="t"
                    :price-formatter="formatPrice"
                    :date-formatter="getDate"
                    :short-date-formatter="getShortDate"
                    :capitalize-formatter="capitalizeFirstLetter"
                    @reset-filters="resetTransactionsFilters"
                    @open-transaction-details="openTransactionDetails"
                  />
                  <WalletOrdersTab
                    v-model:filter-selected-date="filterSelectedDate"
                    v-model:filter-orders-by-type="filterOrdersByType"
                    v-model:filter-orders-by-status="filterOrdersByStatus"
                    v-model:filter-orders-by-exchange="filterOrdersByExchange"
                    v-model:filter-orders-by-period="filterOrdersByPeriod"
                    v-model:sort-orders="sortOrders"
                    v-model:show-orders-filters="showOrdersFilters"
                    v-model:show-orders-sorting="showOrdersSorting"
                    :active-menu-selection="activeMenuSelection"
                    :orders="getAvailableOrders"
                    :loading="isOrdersTabLoading"
                    :exchanges="getExchanges"
                    :order-exchange-filter-disabled="isOrdersExchangeFilterLocked"
                    :windows-width="getWindowsWidth"
                    :user-language="getUserLanguage"
                    :min-date-for-wallet="minDateForWallet"
                    :translator="t"
                    :price-formatter="formatPrice"
                    :bonds-price-formatter="formatBondsPrice"
                    :date-formatter="getDate"
                    :short-date-formatter="getShortDate"
                    :capitalize-formatter="capitalizeFirstLetter"
                    :order-type-formatter="getOrderType"
                    :order-status-formatter="getOrderStatus"
                    :stock-type-resolver="getStockTypeId"
                    @reset-filters="resetOrdersFilters"
                    @confirm-order-cancel="confirmOrderCancel"
                    @update-order="updateOrder"
                    @open-order-details="openOrderDetails"
                  />
                  <WalletTradesTab
                    v-model:filter-selected-date="filterSelectedDate"
                    v-model:filter-trades-by-order-type="filterTradesByOrderType"
                    v-model:filter-trades-by-period="filterTradesByPeriod"
                    v-model:sort-trades="sortTrades"
                    v-model:show-trades-filters="showTradesFilters"
                    v-model:show-trades-sorting="showTradesSorting"
                    :active-menu-selection="activeMenuSelection"
                    :trades="getFilteredTrades"
                    :loading="walletDataLoading && 'Trades' === activeMenuSelection"
                    :windows-width="getWindowsWidth"
                    :user-language="getUserLanguage"
                    :min-date-for-wallet="minDateForWallet"
                    :translator="t"
                    :price-formatter="formatPrice"
                    :bonds-price-formatter="formatBondsPrice"
                    :number-parser="parseNumber"
                    :date-formatter="getDate"
                    :capitalize-formatter="capitalizeFirstLetter"
                    :order-type-formatter="getOrderType"
                    :backend-order-type-formatter="getBackendOrderType"
                    :stock-type-resolver="getStockTypeId"
                    @reset-filters="resetTradesFilters"
                    @open-trade-details="openTradeDetails"
                  />
                  <WalletOrdersTab
                    v-model:filter-selected-date="filterSelectedDate"
                    v-model:filter-orders-by-type="filterOrdersByType"
                    v-model:filter-orders-by-status="filterOrdersByStatus"
                    v-model:filter-orders-by-period="filterOrdersByPeriod"
                    v-model:sort-orders="sortOrders"
                    v-model:show-orders-filters="showOrdersFilters"
                    v-model:show-orders-sorting="showOrdersSorting"
                    tab-name="Pending"
                    :active-menu-selection="activeMenuSelection"
                    :orders="getPendingOrders"
                    :loading="isPendingOrdersTabLoading"
                    :windows-width="getWindowsWidth"
                    :user-language="getUserLanguage"
                    :min-date-for-wallet="minDateForWallet"
                    :translator="t"
                    :price-formatter="formatPrice"
                    :bonds-price-formatter="formatBondsPrice"
                    :date-formatter="getDate"
                    :short-date-formatter="getShortDate"
                    :capitalize-formatter="capitalizeFirstLetter"
                    :order-type-formatter="getOrderType"
                    :order-status-formatter="getOrderStatus"
                    :stock-type-resolver="getStockTypeId"
                    @reset-filters="resetOrdersFilters"
                    @confirm-order-cancel="confirmOrderCancel"
                    @update-order="updateOrder"
                    @open-order-details="openOrderDetails"
                  />
                  <WalletTransfersTab
                    v-model:filter-selected-date="filterSelectedDate"
                    v-model:filter-transfers-by-type="filterTransfersByType"
                    v-model:filter-transfers-by-period="filterTransfersByPeriod"
                    v-model:sort-transfers="sortTransfers"
                    v-model:show-transfers-filters="showTransfersFilters"
                    v-model:show-transfers-sorting="showTransfersSorting"
                    :active-menu-selection="activeMenuSelection"
                    :transfers="getFilteredTransfers"
                    :loading="walletDataLoading && 'Transfers' === activeMenuSelection"
                    :windows-width="getWindowsWidth"
                    :user-language="getUserLanguage"
                    :min-date-for-wallet="minDateForWallet"
                    :translator="t"
                    :price-formatter="formatPrice"
                    :bonds-price-formatter="formatBondsPrice"
                    :number-parser="parseNumber"
                    :date-formatter="getDate"
                    :capitalize-formatter="capitalizeFirstLetter"
                    :transfer-type-formatter="getTransferType"
                    :stock-type-resolver="getStockTypeId"
                    @reset-filters="resetTransfersFilters"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppMenu from '@/components/ui/AppMenu.vue';
import UiUtils from "@/assets/js/ui_utils.js";
import ApiUtils from "@/assets/js/api_utils.js";
import http from "@/api/http-common";
import I18n from "@/lang/i18n.js";
import '@vuepic/vue-datepicker/dist/main.css';
import TradeConfirmed from '@/features/trading/components/TradeConfirmed.vue';
import Trading from '@/features/trading/TradingView.vue';
import WalletOrdersTab from "@/features/wallet/components/WalletOrdersTab.vue";
import WalletSummary from "@/features/wallet/components/WalletSummary.vue";
import WalletTabs from "@/features/wallet/components/WalletTabs.vue";
import WalletTransactionsTab from "@/features/wallet/components/WalletTransactionsTab.vue";
import WalletTradesTab from "@/features/wallet/components/WalletTradesTab.vue";
import WalletTransfersTab from "@/features/wallet/components/WalletTransfersTab.vue";
import HttpUtils from "@/assets/js/http_utils.js";
import { cancelOrder as cancelWalletOrder, fetchOrder, fetchOrdersBrief, fetchTrades, fetchTransactions, fetchTransfers, fetchWallet } from "@/features/wallet/wallet-api";
import { getAllExchangeEquitiesValue, getExchangeSummaries } from "@/features/wallet/wallet-exchange-metrics";
import { getBackendOrderTypeLabel, getOrderActionLabel, getOrderStatusLabel, getTransferTypeLabel } from "@/features/wallet/wallet-label-formatters";
import { getPeriodComparable, getPeriodStartDate, sortByDateSymbolName, sortTransactionsBySelection, sortTransfersBySelection } from "@/features/wallet/wallet-list-utils";
import {
  convertCurrencyAmount,
  getMoneyRatio as getWalletMoneyRatio
} from "@/features/wallet/wallet-money-metrics";
import { getCurrencySettlementAmounts as getWalletCurrencySettlementAmounts, getPortfolioSummary } from "@/features/wallet/wallet-portfolio-metrics";
import { closeWalletSseClient, setupWalletStream, startWalletSseMonitor, stopWalletSseMonitor, subscribeForWalletSse } from "@/features/wallet/wallet-sse";
import { buildExecutedOrderMessage, buildRejectedOrderMessage } from "@/features/wallet/wallet-sse-messages";

export default {
  components: {
    AppMenu,
    TradeConfirmed,
    Trading,
    WalletOrdersTab,
    WalletSummary,
    WalletTabs,
    WalletTransactionsTab,
    WalletTradesTab,
    WalletTransfersTab
  },
  data() {
    return {
      orders: [],
      trades: [],
      transactions: [],
      transfers: [],
      /* order ID to cancel or update */
      orderId: "",
      /* 0 - all exchanges, other: exchange id */
      selectedExchange: this.$store.getters["getSelectedExchangeCode"],
      /* active modal dialog for order cancel */
      cancelOrderModalActive: false,
      /* show modal dialog for order cancel */
      cancelOrderModalShow: false,
      /* active modal dialog for order edit */
      editOrderModalActive: false,
      /* show modal dialog for order edit */
      editOrderModalShow: false,
      /* to date selection in unix timestamp */
      dateTo: this.dateToString ? (new Date(this.dateToString)).getTime() : 0,
      dateToString: new Date().toISOString().slice(0, 10), // YTD to be executed by default, so current year
      activeMenuSelection: this.latestActiveMenuSelection ? this.latestActiveMenuSelection : "Summary",
      filterTransactionsByCurrency: 0,
      filterTransactionsByAmount: [1, 2, 3, 4, 5, 6],
      filterTransactionsByPeriod: 4,
      sortTransactions: 1,
      tradeConfirmedModalActive: false,
      tradeConfirmedModalShow: false,
      orderModel: {},
      minDateForWallet: this.getMinDateForFiltering(),
      minYearForWallet: this.getMinDateForFiltering().slice(0, 4),
      hasReestablishingConnectionMessage: false,
      sseVerifier: null,
      hasEvents: false,
      sseClient: null,
      walletQuoteCodes: [],
      filterOrdersByType: 0,
      filterOrdersByStatus: 0,
      filterOrdersByExchange: parseInt(this.$store.getters["getSelectedExchangeCode"]) || 0,
      filterOrdersByPeriod: 4,
      sortOrders: 1,
      filterTradesByOrderType: 0,
      filterTradesByPeriod: 4,
      filterTransfersByType: 0,
      filterTransfersByPeriod: 4,
      sortTrades: 1,
      sortTransfers: 1,
      filterTransactionsByType: 0,
      showTransactionFilters: false,
      showTransactionSorting: false,
      showOrdersFilters: false,
      showOrdersSorting: false,
      showTradesFilters: false,
      showTradesSorting: false,
      showTransfersFilters: false,
      showTransfersSorting: false,
      walletDataLoading: false,
      orderDetailsLoading: false,
      filterSelectedDate: new Date().toISOString().slice(0, 10), // YTD to be executed by default, so current year
    }
  },
  props: {
    latestActiveMenuSelection: {
      required: false,
      type: String,
      default: null
    },
    latestDisplayStock: {
      required: false,
      type: String,
      default: null
    }
  },
  watch: {
    dateToString: function(newVal) {
      this.dateTo = this.convertSelectedDateToToUnixtime;
      if (null !== newVal) {
        (async () => await this.loadWalletDataForMenu(this.activeMenuSelection))();
      }
    },
    getSelectedExchangeCode: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        const selectedExchangeCode = parseInt(newVal);
        this.selectedExchange = selectedExchangeCode;
        if (selectedExchangeCode !== 0) {
          this.filterOrdersByExchange = selectedExchangeCode;
        }
      }
    },
    latestActiveMenuSelection: function(newVal) {
      const menu = newVal || "Summary";
      if (this.activeMenuSelection === menu) {
        (async () => await this.loadWalletDataForMenu(menu))();
      } else {
        this.activeMenuSelection = menu;
      }
    },
    activeMenuSelection: function (newVal) {
      (async () => await this.loadWalletDataForMenu(newVal))();
    },
    stopSseState: function (newVal) {
      if (newVal) {
        if (this.sseClient) {
          closeWalletSseClient(this.sseClient);
          this.$store.commit("setStopSse", false);
        }
      }
    },
    filterSelectedDate: function (newVal) {
      if (!newVal) return;

      if (this.activeMenuSelection === 'Orders') {
        (async () => await this.getOrders())();
      } else if (this.activeMenuSelection === 'Pending') {
        (async () => await this.getPendingOrdersData())();
      } else if (this.activeMenuSelection === 'Trades') {
        (async () => await this.getTrades())();
      } else if (this.activeMenuSelection === 'Transactions') {
        (async () => await this.getTransactions())();
      } else if (this.activeMenuSelection === 'Transfers') {
        (async () => await this.getTransfers())();
      }  
    },
    filterOrdersByPeriod: function(newVal) {
      const period = parseInt(newVal);

      if (!period && period !== 0) return;

      // YTD is default; skip only if you intentionally do not want reload
      if (period === 4) return;

      // if "From date", let filterSelectedDate watcher handle reload
      if (period === 5) return;

      if (this.activeMenuSelection === 'Pending') {
        (async () => await this.getPendingOrdersData())();
      } else {
        (async () => await this.getOrders())();
      }
    },
    filterTradesByPeriod: function(newVal) {
      const period = parseInt(newVal);

      if (!period && period !== 0) return;

      // YTD is default; skip only if you intentionally do not want reload
      if (period === 4) return;

      // if "From date", let filterSelectedDate watcher handle reload
      if (period === 5) return;

      (async () => await this.getTrades())();
    },
    filterTransactionsByPeriod: function(newVal) {
      const period = parseInt(newVal);

      if (!period && period !== 0) return;

      // YTD is default; skip only if you intentionally do not want reload
      if (period === 4) return;

      // if "From date", let filterSelectedDate watcher handle reload
      if (period === 5) return;

      (async () => await this.getTransactions())();
    },
    filterTransfersByPeriod: function(newVal) {
      const period = parseInt(newVal);

      if (!period && period !== 0) return;

      // YTD is default; skip only if you intentionally do not want reload
      if (period === 4) return;

      // if "From date", let filterSelectedDate watcher handle reload
      if (period === 5) return;

      (async () => await this.getTransfers())();
    }
  },
  methods: {
    t(key, ...args) {
      return I18n.t(key, this.getUserLanguage, ...args);
    },
    selectWalletTab(tab) {
      this.activeMenuSelection = tab;
      this.filterSelectedDate = new Date().toISOString().slice(0, 10);
    },
    async loadWalletDataForMenu(menu) {
      this.walletDataLoading = true;
      try {
        if (0 === menu.localeCompare('Equities')) {
          await Promise.all([this.getTrades()]);
        } else if (0 === menu.localeCompare('Orders')) {
          await this.getOrders();
        } else if (0 === menu.localeCompare('Pending')) {
          await this.getPendingOrdersData();
        } else if (0 === menu.localeCompare('Trades')) {
          await this.getTrades();
        } else if (0 === menu.localeCompare('Transactions')) {
          await this.getTransactions();
        } else if (0 === menu.localeCompare('Transfers')) {
          await this.getTransfers();
        }
      } finally {
        this.walletDataLoading = false;
      }
    },
    async getPendingOrdersData() {
      return Promise.resolve();
    },
    getWalletOrderQuoteCodes() {
      const wallet = this.$store.getters["getWallet"];
      const quoteCodes = [];
      wallet?.orders?.forEach(order => {
        const exchangeCode = order?.mic || order?.xcode || order?.xc;
        const stockCode = order?.code || order?.sc;
        if (exchangeCode && stockCode) {
          quoteCodes.push(UiUtils.combineExchangeStockPair(
            exchangeCode.toString().toUpperCase(),
            stockCode.toString().toUpperCase()
          ));
        }
      });

      return [...new Set(quoteCodes)];
    },
    async refreshWalletOrderQuotes(quoteCodes) {
      if (0 === quoteCodes.length) {
        return;
      }

      await this.$store.dispatch("getQuotes", {
        api: http,
        quotes: quoteCodes
      });
    },
    async ensureWalletOrderQuotes() {
      const quoteCodes = this.getWalletOrderQuoteCodes();
      if (this.walletQuoteCodes.join() === quoteCodes.join()) {
        return;
      }

      this.walletQuoteCodes = quoteCodes;
      await this.refreshWalletOrderQuotes(quoteCodes);
    },
    getMinDateForFiltering() {
      const now = new Date();
      const _5yearsAgo = new Date(now.getFullYear() - 5, 1, 1);
      return _5yearsAgo.getFullYear() + "-" + _5yearsAgo.getMonth() + "-" + _5yearsAgo.getDate();
    },
    capitalizeFirstLetter(string) {
      return string
        ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
        : "";
    },
    openTradeDetails(trade) {
      const tradeId =
        trade?.trid ??
        trade?.tid ??
        trade?.trade_id ??
        trade?.oid ??
        trade?.order_id ??
        trade?.id ??
        null;

      if (!tradeId) {
        console.warn("[WalletView] openTradeDetails called without tradeId", trade);
        return;
      }

      const idAsString = String(tradeId);

      this.$store.commit("wallet/setSelectedTradeId", idAsString);
      const fromStore = this.$store.getters["wallet/tradeById"]?.(idAsString) ?? null;
      const selectedTrade = fromStore || trade
        ? {
          ...(fromStore ?? {}),
          ...(trade ?? {})
        }
        : null;
      this.$store.commit("wallet/setSelectedTrade", selectedTrade);

      this.$router.push({ name: "TradeDetails", params: { tradeId: idAsString } });
    },
    openOrderDetails(order) {
      const orderId =
        order?.oid ??
        order?.order_id ??
        order?.id ??
        order?.orderId ??
        null;

      if (!orderId) {
        console.warn("[WalletView] openOrderDetails called without orderId", order);
        return;
      }

      // store selection for details view (no route object passing)
      this.$store.commit("wallet/setSelectedOrderId", String(orderId));
      this.$store.commit("wallet/upsertOrder", order);

      // Prefer lookup from Vuex (keeps things in sync with other entry points),
      // but gracefully fall back to the object we already have in the list.
      const fromList =
        order ??
        this.$store.getters["wallet/orderById"]?.(String(orderId)) ??
        null;

      this.$store.commit("wallet/setSelectedOrder", fromList);

      this.$router.push({
        name: "OrderDetails",
        params: { orderId: String(orderId) },
        query: { latestActiveMenuSelection: this.activeMenuSelection }
      });
    },
    openTransactionDetails(transaction) {
      // browser changes the type from object to string, so we perform a little hack passing string and building the object in the child vue
      this.$router.push({ name: "TransactionDetails", params: { transactionDetails: JSON.stringify(transaction), latestDisplayStock: this.latestDisplayStock } });
    },    
    getUserType() {
      return this.$store.getters["getUserType"];
    },
    openWalletBreakdownByExchange(exchangeId) {
      // Persist wallet data in Vuex (do not pass large objects via the router)
      this.$store.commit("wallet/setSelectedExchangeId", String(exchangeId));
      this.$store.commit("wallet/setOrders", Array.isArray(this.orders) ? this.orders : []);
      this.$store.commit("wallet/setTrades", Array.isArray(this.trades) ? this.trades : []);
      this.$router.push({
        name: "WalletBreakdownByExchange",
        params: { exchangeId: String(exchangeId) },
        query: { latestActiveMenuSelection: this.activeMenuSelection }
      });
    },
    openWalletBreakdownByInstrumentType(groupKey) {
      this.$store.commit("wallet/setOrders", Array.isArray(this.orders) ? this.orders : []);
      this.$store.commit("wallet/setTrades", Array.isArray(this.trades) ? this.trades : []);
      this.$router.push({
        name: "WalletBreakdownByInstrumentType",
        params: { groupKey: String(groupKey) },
        query: { latestActiveMenuSelection: this.activeMenuSelection }
      });
    },
    async subscribeForSse() {
      const user = this.$store.getters["getUser"];
      try {
        const res = await subscribeForWalletSse(this.getUserType(), user);
        if (res) {
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);
          if (errorCode !== "") {
            this.showToastError(errorCode);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },    
    setupStream() {
      const user = this.$store.getters["getUser"];
      if (!user) {
        return;
      }

      try {
        this.sseClient = setupWalletStream({
          userType: this.getUserType(),
          user,
          onHeartbeat: () => this.markSseEventsReceived(),
          onSessionClosed: () => {
            this.markSseEventsReceived();
            ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.t("invalidSessionLabel"), 1);
          },
          onWallet: event => this.handleWalletSseEvent(event),
          onExecuted: event => this.handleExecutedSseEvent(event),
          onRejected: event => this.handleRejectedSseEvent(event),
          onQuoteTrading: event => this.handleQuoteTradingSseEvent(event),
          onDepth: event => this.handleDepthSseEvent(event),
          onError: event => this.handleSseError(event)
        });
        if (!this.sseClient) {
          return;
        }
        this.handleSseReestablished();
      } catch (error) {
        console.error(error)
      }

    },
    getStockName(stockCode) {
      const stocks = this.$store.getters["getStocks"];
      const indexedStocks = this.$store.getters["getIndexedStocks"];

      return UiUtils.getStockName(stocks, indexedStocks, stockCode, this.getUserLanguage); 
    },
    getStockTypeId(stockCode, exCode) {
      if (!stockCode || !exCode) {
        return 1;
      }
      const exchangeId = UiUtils.getExchangeIdByCode(this.getExchanges, exCode);
      const indexedStocks = this.$store.getters["getIndexedStocks"];
      const stocks = this.$store.getters["getStocks"];
      const stockIndex = indexedStocks.indexOf(exchangeId + stockCode);

      return stocks[stockIndex]?.tID || 1;
    },
    getOrderStock(order) {
      if (!order?.code || !order?.xcode) {
        return null;
      }
      const exchangeId = UiUtils.getExchangeIdByCode(this.getExchanges, order.xcode);
      const stocks = this.$store.getters["getStocks"];
      const indexedStocks = this.$store.getters["getIndexedStocks"];

      return UiUtils.getStock(stocks, indexedStocks, exchangeId, order.code);
    },
    confirmOrderCancel(orderId) {
      this.orderId = orderId;
      this.cancelOrderModalActive = true;
      this.cancelOrderModalShow = true;
    },
    blurActiveElement() {
      if (document.activeElement && "function" === typeof document.activeElement.blur) {
        document.activeElement.blur();
      }
    },
    closeTradeConfirmedModal() {
      this.blurActiveElement();
      this.tradeConfirmedModalActive = false;
      this.tradeConfirmedModalShow = false;
    },
    async confirmAndCloseCancelOrderModal() {
      this.blurActiveElement();
      await this.cancelOrder();
      this.closeCancelOrderModal();
    },
    closeCancelOrderModal() {
      this.blurActiveElement();
      this.cancelOrderModalActive = false;
      this.cancelOrderModalShow = false;
    },
    closeEditOrderModal() {
      this.blurActiveElement();
      this.editOrderModalActive = false;
      this.editOrderModalShow = false;
    },
    async updateOrder(order) {
      // extract order details from API
      const user = this.$store.getters["getUser"];
      const res = await fetchOrder(this.getUserType(), user, order.order_id);
      if (res && res.data.ec === 0) {
        order.validity = res.data.validity;
        order.rest_code = res.data.rest_code;
        order.stop = res.data.stop;
        order.peak = res.data.peak;
        order.tac = res.data.tac;
        order.sgm = res.data.sgm || order.sgm;
      }
      if (!order.sgm) {
        order.sgm = this.getOrderStock(order)?.sgm || "";
      }
      this.$store.commit("setOrderToEdit", order);
      this.$nextTick(() => {
        this.editOrderModalActive = true;
        this.editOrderModalShow = true;      
      });
    },
    getDate(unix) {
      return UiUtils.parseUnixTime(unix);
    },
    getShortDate(unix) {
      return this.getDate(unix).slice(0, 9);
    },
    getDateFromMs(unix) {
      return new Date(unix).toISOString().slice(0, 19).replace('T', ' ');
    },
    reformatExpiryOrderDateToUnixtimestamp(date) {
      return Math.floor(new Date(date).getTime() / 1000)
    },
    getShortDateFromMs(unix) {
      return new Date(unix).toISOString().slice(0, 10);
    },
    getOrderType(ot) {
      return getOrderActionLabel(ot, {
        buy: this.t("buyLabel"),
        sell: this.t("sellLabel")
      });
    },
    getBackendOrderType(type) {
      return getBackendOrderTypeLabel(type, {
        market: this.t("marketLabel"),
        limit: this.t("limitLabel"),
        stopLimit: this.t("stopLimitLabel"),
        stopMarket: this.t("stopMarketLabel"),
        iceberg: this.t("icebergLabel")
      });
    },
    getTransferType(ot) {
      return getTransferTypeLabel(ot, {
        incoming: this.t("incomingLabel"),
        outgoing: this.t("outgoingLabel")
      });
    },
    getWalletOrders() {
      return this.$store.getters["wallet/orders"] ?? [];
    },
    hasWalletOrders() {
      return Array.isArray(this.getWalletOrders()) && 0 < this.getWalletOrders().length;
    },
    normalizeWalletOrder(order) {
      if (!order) {
        return order;
      }

      const normalizedType = this.normalizeWalletOrderType(order.type);
      return {
        ...order,
        acquired: order.acquired ?? order.ts,
        action: order.action ?? order.act,
        type: normalizedType,
        code: order.code,
        amount: order.amount ?? order.cnt,
        price: order.price ?? order.pr,
        fee: order.fee,
        exp_date: order.exp_date ?? order.exp,
        order_id: order.order_id ?? order.oid ?? order.id,
        status: order.status ?? order.sts,
        cc: order.cc,
        xcode: order.xcode ?? order.mic,
        segment: order.segment,
        nEN: order.nEN,
        nBG: order.nBG,
        stid: order.stid
      };
    },
    normalizeWalletOrderType(type) {
      if (type == null) {
        return "";
      }

      const normalizedType = type.toString().toUpperCase();
      switch (normalizedType) {
        case "1":
          return "MARKET";
        case "2":
          return "LIMIT";
        case "3":
          return "STOP-MARKET";
        case "4":
          return "ICEBERG";
        case "5":
          return "STOP-LIMIT";
        default:
          return normalizedType;
      }
    },
    getOrderById(orderId) {
      const target = String(orderId ?? "");
      const allOrders = [
        ...(Array.isArray(this.orders) ? this.orders : []),
        ...(this.hasWalletOrders() ? this.getWalletOrders().map(item => this.normalizeWalletOrder(item)) : [])
      ];
      const filtered = allOrders.filter(item => {
        const id = item.order_id ?? item.oid ?? item.id;
        return 0 === target.localeCompare(String(id ?? ""));
      });
      return filtered ? filtered[0] : null;
    },
    getOrderStatus(order) {
        return getOrderStatusLabel(order, {
            processing: this.t("processingLabel"),
            placed: this.t("placedLabel"),
            cancelled: this.t("cancelledLabel"),
            filled: this.t("filledLabel")
        });
    },
    handleInvalidSessionResponse(res) {
      if (ApiUtils.handleTraderNonRecoverableError(res, this.$store, this.$router, this.getUserLanguage)) {
        this.$store.commit("setAppStateReady");
        return true;
      }
      if (!ApiUtils.isApiResponseInvalidSession(res)) {
        return false;
      }
      this.$store.commit("setAppStateReady");
      setTimeout(
        ApiUtils.cleanAndLogoutOnError(this.$store, this.$router, this.t("invalidSessionLabel"), 1),
        500);
      return true;
    },
    addSystemMessage(message, error = false) {
      this.$store.commit("addSystemMessage", {
        date: (new Date()).getTime(),
        mess: message,
        error
      });
    },
    showToastError(message) {
      this.$toast.error(message, {
        "duration": 5000,
        "pauseOnHover": true
      });
      this.addSystemMessage(message, true);
    },
    showToastSuccess(message) {
      this.$toast.success(message, {
        "duration": 5000,
        "pauseOnHover": true
      });
      this.addSystemMessage(message, false);
    },
    getWalletRequestRange(period) {
      const endDate = new Date();
      const startDate = getPeriodStartDate(period, this.filterSelectedDate);
      return {
        from: startDate.toISOString().slice(0, 10),
        to: !this.dateTo
          ? endDate.toISOString().slice(0, 10)
          : this.getShortDateFromMs(this.dateTo)
      };
    },
    async getOrders() {
      try {
        this.$store.commit("setAppStateNotReady");
        const user = this.$store.getters["getUser"];
        const range = this.getWalletRequestRange(this.filterOrdersByPeriod);
        const res = await fetchOrdersBrief(
          this.getUserType(),
          user,
          range.from,
          range.to
        );
        if (res) {
          if (this.handleInvalidSessionResponse(res)) {
            return;
          }
          if (0 === res.data.ec) {
            this.orders = res.data.list;
            this.$store.commit("setAppStateReady");
          } else {
            this.$store.commit("setAppStateReady");
            this.showToastError(this.t("couldNotReadOrdersMessage"));
          }
        }
        this.$store.commit("wallet/setOrders", this.orders);
        this.$store.commit("setAppStateReady");        
      } catch (err) {
        console.error(err);
      }
    },
    async cancelOrder() {
      if (!this.orderId) {
        return;
      }
      try {
        this.$store.commit("setAppStateNotReady");
        const user = this.$store.getters["getUser"];
        const res = await cancelWalletOrder(this.getUserType(), user, this.orderId);
        if (res) {
          if (this.handleInvalidSessionResponse(res)) {
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);

          if (errorCode === "") {
            this.showToastSuccess(this.t("cancelledOrderMessage"));
            setTimeout(async () => {
              // update orders
              await this.getOrders();
              this.$store.commit("setAppStateReady");
            }, 1200);
          } else {
            this.showToastError(errorCode);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getTrades() {
      try {
        this.$store.commit("setAppStateNotReady");
        const user = this.$store.getters["getUser"];
        const range = this.getWalletRequestRange(this.filterTradesByPeriod);
        const res = await fetchTrades(
          this.getUserType(),
          user,
          range.from,
          range.to
        );
        if (res) {
          if (this.handleInvalidSessionResponse(res)) {
            return;
          }          
          if (0 === res.data.ec) {
            this.trades = res.data.stocks;
            this.$store.commit("setAppStateReady");
          } else {
            this.$store.commit("setAppStateReady");
            this.showToastError(this.t("couldNotReadTradesMessage"));
          }
        }
        this.$store.commit("wallet/setTrades", this.trades);
        this.$store.commit("setAppStateReady");
      } catch (err) {
        console.error(err);
      }
    },
    async getWallet() {
      const user = this.$store.getters["getUser"];
      try {
        const date = !this.dateTo
          ? Math.floor((new Date()).getTime() / 1000)
          : Math.floor(this.dateTo / 1000);
        const res = await fetchWallet(this.getUserType(), user, date);
        if (res) {
          if (this.handleInvalidSessionResponse(res)) {
            return;
          }
          // get the error message if appropriate
          const errorCode = HttpUtils.getStatusMessage(res.data.ec, this.getUserLanguage);
          if (errorCode === "") {
            this.$store.commit("wallet/setWallet", res.data);
            await this.ensureWalletOrderQuotes();
          } else {
            this.showToastError(errorCode);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getTransactions() {
      const user = this.$store.getters["getUser"];
      try {
        this.$store.commit("setAppStateNotReady");
        const range = this.getWalletRequestRange(this.filterTransactionsByPeriod);
        const res = await fetchTransactions(
          this.getUserType(),
          user,
          range.from,
          range.to
        );
        if (res) {
          if (this.handleInvalidSessionResponse(res)) {
            return;
          }          
          if (0 === res.data.ec) {
            this.transactions = res.data.t;
            this.$store.commit("setAppStateReady");
          } else {
            this.$store.commit("setAppStateReady");
            this.showToastError(this.t("couldNotReadWalletMessage"));
          }
        }
        this.$store.commit("setAppStateReady");        
      } catch (err) {
        console.error(err);
      }
    },
    async getTransfers() {
      // only for live users
      if (this.getUserType() === 0) return;

      const user = this.$store.getters["getUser"];
      try {
        this.$store.commit("setAppStateNotReady");
        const range = this.getWalletRequestRange(this.filterTransfersByPeriod);
        const res = await fetchTransfers(
          this.getUserType(),
          user,
          range.from,
          range.to
        );
        if (res) {
          if (this.handleInvalidSessionResponse(res)) {
            return;
          }          
          if (0 === res.data.ec) {
            this.transfers = res.data.stocks;
            this.$store.commit("setAppStateReady");
          } else {
            this.$store.commit("setAppStateReady");
            this.showToastError(this.t("couldNotReadWalletMessage"));
          }
        }
        this.$store.commit("setAppStateReady");        
      } catch (err) {
        console.error(err);
      }
    },    
    parseNumber(num, afterDot = 2) {
      return UiUtils.formatNumber(num, afterDot);
    },
    getMoneyRatio(currency) {
      const wallet = this.$store.getters["getWallet"];
      return getWalletMoneyRatio(wallet, currency);
    },
    getCurrencyAsPercentFromTotalMoney(curr) {
      if (0 === this.totalMoneyValue) {
        return 0;
      }
      return Math.min(Math.max(parseFloat((this.getMoneyAmountInSelectedCurrency(curr) / this.totalMoneyValue) * 100), 0), 100);
    },
    getCurrencyAsPercentFromTotalBalance(curr) {
      const totalBalance = this.totalBalance;
      if (0 === totalBalance) {
        return 0;
      }
      return Math.min(Math.max(parseFloat((this.getMoneyAmountInSelectedCurrency(curr) / totalBalance) * 100), 0), 100);
    },
    getMoneyAmountInSelectedCurrency(curr) {
      return this.getCurrencyAmountInSelectedCurrency(curr.a, curr.c);
    },
    getCurrencyAmountInSelectedCurrency(amount, currency) {
      const wallet = this.$store.getters["getWallet"];
      return convertCurrencyAmount({
        wallet,
        amount,
        sourceCurrency: currency,
        targetCurrency: this.getCurrency
      });
    },
    getCurrencySettlementAmounts(currency) {
      const userWallet = this.$store.getters["getWallet"];
      return getWalletCurrencySettlementAmounts({
        wallet: userWallet,
        currency
      });
    },
    formOrderObject(event) {
      this.orderModel.type = this.getOrderType(event.t);
      this.orderModel.ex = event.xc;
      this.orderModel.code = event.sc;
      this.orderModel.name = 0 === 'BG'.localeCompare(this.getUserLanguage)
        ? event.nBG
        : event.nEN;
      this.orderModel.amount = this.parseNumber(event.qty);
      this.orderModel.price = event.sp;
      this.orderModel.price_total = event.pt;
      this.orderModel.currency = event.cc;
      this.orderModel.stid = event.stid;
      this.orderModel.oid = event.id;
      this.orderModel.fee = event.fee;
      this.orderModel.time = this.getDate(event.d);
      this.orderModel.total_amount = Number(event.pt || 0) + Number(event.fee || 0);
    },
    formatBondsPrice(val, autoDigits = null) {
      return UiUtils.formatPrice(val, '%', this.getUserLanguage, autoDigits);
    },
    formatPrice(val, curr, autoDigits = null) {
      return UiUtils.formatPrice(val, curr, this.getUserLanguage, autoDigits);
    },
    resetOrdersFilters() {
      this.filterOrdersByType = 0;
      this.filterOrdersByStatus = 0;
      this.filterOrdersByExchange = this.isOrdersExchangeFilterLocked
        ? parseInt(this.getSelectedExchangeCode)
        : 0;
      this.filterOrdersByPeriod = 4;
    },
    resetTransactionsFilters() {
      this.filterTransactionsByAmount = [1, 2, 3, 4, 5, 6];
      this.filterTransactionsByCurrency = 0;
      this.filterTransactionsByPeriod = 4;
    },
    resetTradesFilters() {
      this.filterTradesByOrderType = 0;
      this.filterTradesByPeriod = 4;
    },
    resetTransfersFilters() {
      this.filterTransfersByType = 0;
      this.filterTransfersByPeriod = 4;
    },
    markSseEventsReceived() {
      this.hasEvents = true;
    },
    handleSseReestablished() {
      if (!this.hasReestablishingConnectionMessage) {
        return;
      }
      this.showToastSuccess(this.t("reestablishedConnectionLabel"));
      this.hasReestablishingConnectionMessage = false;
    },
    handleWalletSseEvent(event) {
      this.markSseEventsReceived();
      try {
        this.$store.commit("wallet/setWallet", JSON.parse(event.data));
        (async () => await this.ensureWalletOrderQuotes())();
      } catch (err) {
        console.error(err);
      }
    },
    handleExecutedSseEvent(event) {
      this.markSseEventsReceived();
      try {
        const orderData = JSON.parse(event.data);
        this.formOrderObject(orderData);
        this.tradeConfirmedModalShow = true;
        this.tradeConfirmedModalActive = true;
        const mess = buildExecutedOrderMessage(
          orderData,
          this.getUserLanguage,
          this.getDate,
          this.getOrderType,
          this.getStockName
        );
        this.showToastSuccess(mess);
      } catch (err) {
        console.error(err);
      }
    },
    handleRejectedSseEvent(event) {
      this.markSseEventsReceived();
      try {
        const orderData = JSON.parse(event.data);
        const mess = buildRejectedOrderMessage(orderData, this.getUserLanguage, this.getDate);
        this.showToastError(mess);
      } catch (err) {
        console.error(err);
      }
    },
    handleQuoteTradingSseEvent(event) {
      this.markSseEventsReceived();
      try {
        this.$store.commit("setQuoteTrading", JSON.parse(event.data));
      } catch (err) {
        console.error(err);
      }
    },
    handleDepthSseEvent(event) {
      this.markSseEventsReceived();
      try {
        this.$store.commit("setDepth", JSON.parse(event.data));
      } catch (err) {
        console.error(err);
      }
    },
    isWalletChildRoute(routeName) {
      if ("string" !== typeof routeName) {
        return false;
      }

      return [
        "OrderDetails",
        "TradeDetails",
        "TransactionDetails",
        "WalletBreakdownByExchange",
        "WalletBreakdownByInstrumentType"
      ].includes(routeName);
    },
    handleSseError(event) {
      this.hasEvents = false;
      try {
        if (event.readyState == EventSource.CLOSED) {
          console.log(EventSource);
        }
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    getWindowsWidth() {
      return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
    },     
    walletSummaryData() {
      const selectedExchange = this.getSelectedExchange;
      const selectedExchangeCode = this.getSelectedExchangeCode;
      const userWallet = this.$store.getters["getWallet"];
      const stocks = this.$store.getters["getStocks"];
      const indexedStocks = this.$store.getters["getIndexedStocks"];

      return {
        currency: this.getCurrency,
        windowsWidth: this.getWindowsWidth,
        allEquitiesValueInCurrentCurrency: this.getAllEquitiesValueInCurrentCurrency,
        availableToWithdraw: this.getAvailableToWithdraw,
        equitiesPercentage: this.getEquitiesPercentage,
        excessFunds: this.getExcessFunds,
        freeFunds: this.getFreeFunds,
        guaranteeDeposit: this.getGuaranteeDeposit,
        moneyPercentage: this.getMoneyPercentage,
        positionsBreakdownTab: this.$route.query.positionsBreakdownTab ? String(this.$route.query.positionsBreakdownTab) : null,
        positionGroupSummaries: this.portfolioSummary.positionGroupSummaries,
        selectedExchange: this.getSelectedExchange,
        selectedExchangeCode: this.getSelectedExchangeCode,
        totalAssetsValue: this.totalAssetsValue,
        totalBalance: this.totalBalance,
        totalBuySettlementAmount: this.totalBuySettlementAmount,
        totalSellSettlementAmount: this.totalSellSettlementAmount,
        totalEquitiesValue: this.totalEquitiesValue,
        userMoney: this.getUserMoney,
        exchangeSummaries: getExchangeSummaries({
          currency: this.getCurrency,
          wallet: userWallet,
          stocks,
          indexedStocks,
          selectedExchange,
          selectedExchangeCode
        })
      };
    },
    walletTabLabels() {
      return {
        summary: this.t("summaryMenuItem"),
        cash: this.t("moneyLabel"),
        equities: this.t("positionsMenuItem"),
        pending: this.t("pendingMenuItem"),
        orders: this.t("ordersMenuItem"),
        trades: this.t("tradesMenuItem"),
        transfers: this.t("transfersMenuItem"),
        transactions: this.t("transactionsMenuItem")
      };
    },
    isOrdersTabLoading() {
      return (this.walletDataLoading || this.orderDetailsLoading) && "Orders" === this.activeMenuSelection;
    },
    isPendingOrdersTabLoading() {
      return (this.walletDataLoading || this.orderDetailsLoading) && "Pending" === this.activeMenuSelection;
    },
    getSelectedExchangeCode() {
      return this.$store.getters["getSelectedExchangeCode"];
    },
    portfolioSummary() {
      const userWallet = this.$store.getters["getWallet"];
      const stocks = this.$store.getters["getStocks"];
      const indexedStocks = this.$store.getters["getIndexedStocks"];
      const quotes = this.$store.getters["getQuotes"];

      return getPortfolioSummary({
        wallet: userWallet,
        stocks,
        indexedStocks,
        quotes,
        currency: this.getCurrency
      });
    },
    getUserCurrencies() {
      if (!this.transactions) {
        return [];
      }
      const allUserCurrenciesInWallet = [];
      this.transactions.forEach(element => {
        if (!allUserCurrenciesInWallet.includes(element.cc)) {
          allUserCurrenciesInWallet.push(element.cc);
        }
      });

      return allUserCurrenciesInWallet;
    },
    getUserMoney() {
      const wallet = this.$store.getters["getWallet"];
      return wallet.m;
    },
    totalMoneyValue() {
      return this.portfolioSummary.totalAssetsValue;
    },
    totalEquitiesValue() {
      return this.portfolioSummary.totalEquitiesValue;
    },
    getAvailableTransactions() {      
      let filteredTransaction = this.transactions || [];

      // get selected currency
      if(parseInt(this.filterTransactionsByCurrency) !== 0) {
        const bgn = "bgn";
        const eur = "eur";
        const includeArr = [];
        const excludeArr = [];
        switch(parseInt(this.filterTransactionsByCurrency)) {
          case 1: {
            // bgn
            includeArr.push(bgn);
            break;
          }
          case 2: {
            // eur
            includeArr.push(eur);
            break;
          }
          default: {
            // any other
            excludeArr.push(bgn);
            excludeArr.push(eur);
            break;
          }
        }
        if (excludeArr.length > 0) {
          filteredTransaction = filteredTransaction.filter(item => {
            return !excludeArr.includes(item.cc?.toString()?.toLowerCase());
          });
        } else {
          filteredTransaction = filteredTransaction.filter(item => {
            return includeArr.includes(item.cc?.toString()?.toLowerCase());
          });
        }
      }

      const comparable = getPeriodComparable(this.filterTransactionsByPeriod, this.filterSelectedDate);
      filteredTransaction = filteredTransaction.filter(item => {
        return parseInt(item.ts) > comparable;
      });       

      // filter by transaction amount
      const selectedAmountRanges = Array.isArray(this.filterTransactionsByAmount)
        ? this.filterTransactionsByAmount.map(item => parseInt(item))
        : (parseInt(this.filterTransactionsByAmount) === 0
          ? [1, 2, 3, 4, 5, 6]
          : [parseInt(this.filterTransactionsByAmount)]);

      if (selectedAmountRanges.length === 0) {
        filteredTransaction = [];
      } else if (selectedAmountRanges.length < 6) {
        filteredTransaction = filteredTransaction.filter(item => {
          const amount = parseFloat(item.am);
          return selectedAmountRanges.some(range => {
            switch (range) {
              case 1:
                return amount > 10000;
              case 2:
                return amount > 1000 && amount <= 10000;
              case 3:
                return amount > 100 && amount <= 1000;
              case 4:
                return amount > 10 && amount <= 100;
              case 5:
                return amount >= 1 && amount <= 10;
              case 6:
                return amount < 1;
              default:
                return false;
            }
          });
        });
      }

      // filter by transaction type
      if(parseInt(this.filterTransactionsByType) !== 0) {
        let compareString = "";
        switch (parseInt(this.filterTransactionsByType)) {
          case 1: {
            // dividend
            compareString = "dividend";
            break;
          }
          case 2: {
            // exchange
            compareString = "exchange";
            break;
          }
          case 3: {
            // transaction
            compareString = "transaction";
            break;
          }
        }
        filteredTransaction = filteredTransaction.filter(item => {
          return compareString.localeCompare(item.tt?.toString()?.toLowerCase()) === 0;
        });
      }

      filteredTransaction = sortTransactionsBySelection(filteredTransaction, this.sortTransactions);

      return filteredTransaction;
    },
    getAvailableOrders() {
      if (!this.orders) {
        return [];
      }
      let filteredOrder = this.orders;

      // check locally selected order exchange
      if (parseInt(this.filterOrdersByExchange) !== 0) {
        const exchange = UiUtils.getExchangeCodeById(this.getExchanges, this.filterOrdersByExchange);
        filteredOrder = filteredOrder.filter(item => {
          return item.xcode?.toUpperCase().localeCompare(exchange.toUpperCase()) === 0;
        });
      }
      // check order type
      if (parseInt(this.filterOrdersByType) !== 0) {
        const action = parseInt(this.filterOrdersByType) === 1
          ? 'B'
          : 'S';
        filteredOrder = filteredOrder.filter(item => {
          return item.action?.toUpperCase().localeCompare(action) === 0;
        });
      }
      // check order status
      if (parseInt(this.filterOrdersByStatus) !== 0) {
        const allowedStatuses = [];
        switch (parseInt(this.filterOrdersByStatus)) {
          case 1: {
            // acquired
            allowedStatuses.push(...[1, 2, 12, 99]);
            break;
          }
          case 2: {
            // placed
            allowedStatuses.push(...[3]);
            break;
          }
          case 3: {
            // cancelled
            allowedStatuses.push(...[4, 5]);
            break;
          }
          case 4: {
            // filled
            allowedStatuses.push(...[6, 7]);
            break;
          }
        }
        filteredOrder = filteredOrder.filter(item => {
          return allowedStatuses.includes(parseInt(item.status));
        });
      }

      const comparable = getPeriodComparable(this.filterOrdersByPeriod, this.filterSelectedDate);
      filteredOrder = filteredOrder.filter(item => {
        return parseInt(item.acquired) > comparable;
      });

      filteredOrder = sortByDateSymbolName(filteredOrder, this.sortOrders, "acquired", "code", "nEN");

      return filteredOrder;
    },
    isOrdersExchangeFilterLocked() {
      return parseInt(this.getSelectedExchangeCode) !== 0;
    },
    getPendingOrders() {
      const sourceOrders = this.hasWalletOrders()
        ? this.getWalletOrders().map(item => this.normalizeWalletOrder(item))
        : this.orders;

      if (!sourceOrders) {
        return [];
      }
      let filteredOrder = sourceOrders;

      // only pending statuses
      const allowedStatuses = [];
      allowedStatuses.push(...[1, 2, 3, 12, 99]);
      filteredOrder = filteredOrder.filter(item => {
        return allowedStatuses.includes(parseInt(item.status));
      });     

      // check selected exchange
      if (parseInt(this.getSelectedExchangeCode) !== 0) {
        const exchange = UiUtils.getExchangeCodeById(this.getExchanges, this.getSelectedExchangeCode);
        filteredOrder = filteredOrder.filter(item => {
          return item.xcode?.toUpperCase().localeCompare(exchange.toUpperCase()) === 0;
        });
      }
      // check order type
      if (parseInt(this.filterOrdersByType) !== 0) {
        const action = parseInt(this.filterOrdersByType) === 1
          ? 'B'
          : 'S';
        filteredOrder = filteredOrder.filter(item => {
          return item.action?.toUpperCase().localeCompare(action) === 0;
        });
      }

      const comparable = getPeriodComparable(this.filterOrdersByPeriod, this.filterSelectedDate);
      filteredOrder = filteredOrder.filter(item => {
        return parseInt(item.acquired) > comparable;
      });

      filteredOrder = sortByDateSymbolName(filteredOrder, this.sortOrders, "acquired", "code", "nEN");

      return filteredOrder;
    },
    getUserLanguage() {
      return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
    },
    getCurrency() {
      return this.$store.getters["getCurrency"].toUpperCase();
    },
    getAllEquitiesValueInCurrentCurrency() {
      const userWallet = this.$store.getters["getWallet"];
      const stocks = this.$store.getters["getStocks"];
      const indexedStocks = this.$store.getters["getIndexedStocks"];

      return getAllExchangeEquitiesValue({
        stocks,
        indexedStocks,
        wallet: userWallet,
        currency: this.getCurrency
      });
    },
    getExchanges() {
      return this.$store.getters["getExchanges"];
    },
    totalAssetsValue() {
      return this.portfolioSummary.totalAssetsValue;
    },
    totalBalance() {
      return this.portfolioSummary.totalBalance;
    },
    getMoneyPercentage() {
      return this.parseNumber(this.portfolioSummary.moneyPercentage);
    },
    getEquitiesPercentage() {
      return this.parseNumber(this.portfolioSummary.equitiesPercentage);
    },
    convertSelectedDateFromToUnixtime() {      
      return "" !== this.dateFromString 
        ? (new Date(this.dateFromString)).getTime() 
        : 0;
    },
    convertSelectedDateToToUnixtime() {
      return "" !== this.dateToString 
        ? (new Date(this.dateToString)).getTime() 
        : 0;
    },
    getMinWalletDate() {
      const transactions = this.transactions;
      if (!transactions){
        return new Date().toISOString().slice(0, 10);
      }
      // get first transaction
      let firstTransaction = null;
      transactions.forEach(trans => {
        if (null === firstTransaction) {
          firstTransaction = trans;
        } else {
          if (parseInt(firstTransaction.ts) > parseInt(trans.ts)) {
            firstTransaction = trans;
          }
        }
      });
      return null !== firstTransaction ?
        this.getShortDate(firstTransaction.ts) :
        new Date().toISOString().slice(0, 10);
    },
    getSelectedExchange() {
      const exchanges = this.$store.getters["getExchanges"];
      return exchanges.filter(item => {
        return parseInt(item.eID) === parseInt(this.getSelectedExchangeCode);
      })[0];
    },
    getFilteredTrades() {
      let tradesToReturn = this.trades;
      if (!tradesToReturn) {
        return [];
      }
      // filter by exchange
      const selectedExchange = this.getSelectedExchange;
      if (selectedExchange) {
        tradesToReturn = tradesToReturn.filter(item => {
          return item?.xc?.toLowerCase().localeCompare(selectedExchange.code.toLowerCase()) === 0;
        });
      }

      // check order type
      if (parseInt(this.filterTradesByOrderType) !== 0) {
        const action = parseInt(this.filterTradesByOrderType) === 1
          ? 'B'
          : 'S';
        tradesToReturn = tradesToReturn.filter(item => {
          return item.tt?.toUpperCase().localeCompare(action) === 0;
        });        
      }

      const comparable = getPeriodComparable(this.filterTradesByPeriod, this.filterSelectedDate);
      tradesToReturn = tradesToReturn.filter(item => {
        return parseInt(item.ts) > comparable;
      });      

      tradesToReturn = sortByDateSymbolName(tradesToReturn, this.sortTrades, "ts", "sc", "nEN");

      return tradesToReturn;
    },
    getFilteredTransfers() {
      let transfersToReturn = this.transfers;
      if (!transfersToReturn) {
        return [];
      }
      // filter by exchange
      const selectedExchange = this.getSelectedExchange;
      if (selectedExchange) {
        transfersToReturn = transfersToReturn.filter(item => {
          return item?.xc?.toLowerCase().localeCompare(selectedExchange.code.toLowerCase()) === 0;
        });
      }

      // check order type
      if (parseInt(this.filterTransfersByType) !== 0) {
        const action = parseInt(this.filterTransfersByType) === 1
          ? 'B'
          : 'S';
        transfersToReturn = transfersToReturn.filter(item => {
          return item.tt?.toUpperCase().localeCompare(action) === 0;
        });        
      }

      const comparable = getPeriodComparable(this.filterTransfersByPeriod, this.filterSelectedDate);
      transfersToReturn = transfersToReturn.filter(item => {
        return parseInt(item.ts) > comparable;
      });      

      transfersToReturn = sortTransfersBySelection(transfersToReturn, this.sortTransfers);

      return transfersToReturn;
    },
    totalBuySettlementAmount() {
      return this.portfolioSummary.totalBuySettlementAmount;
    },
    totalSellSettlementAmount() {
      return this.portfolioSummary.totalSellSettlementAmount;
    },
    getFreeFunds() {
      return this.portfolioSummary.freeFunds;
    },
    getGuaranteeDeposit() {
      return this.portfolioSummary.guaranteeDeposit;
    },
    getExcessFunds() {
      return this.portfolioSummary.excessFunds;
    },
    getAvailableToWithdraw() {
      return this.portfolioSummary.availableToWithdraw;
    },
    stopSseState() {
      return this.$store.getters["getStopSse"];
    }
  },
  async mounted() {
    await this.loadWalletDataForMenu(this.activeMenuSelection);
    await this.ensureWalletOrderQuotes();
    await this.subscribeForSse();
    // start sse
    this.setupStream();
    // start sse monitor
    this.sseVerifier = startWalletSseMonitor({
      getClient: () => this.sseClient,
      setClient: (client) => { this.sseClient = client; },
      hasEvents: () => this.hasEvents,
      setupStream: () => this.setupStream()
    });
  },
  async unmounted() {
    // stop verifier
    stopWalletSseMonitor(this.sseVerifier);
    // close sse
    closeWalletSseClient(this.sseClient);
    // restore wallet
    this.dateTo = 0;
    if (!this.isWalletChildRoute(this.$route?.name)) {
      await this.getWallet();
    }
  }
}
</script>

<style scoped>
  .wallet-menu-column {
    align-self: flex-start;
  }

  th {
    text-align: left
  }
  .xsmall-font-size {
    font-size: x-small;
  }

  #user-stocks {
    max-height: 35rem;
    overflow-y: auto;
    overflow-x: hidden;
  }
  span {
    display: inline-block;
    width: 11rem;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
  .greenColor {
    color: #189e18;
  }

  .redColor {
    color: #ff0000;
  }

  .data-column {
    min-width: 4.5rem;
    vertical-align: middle;
    text-align: center;
  }

  .data-column-large {
    min-width: 4.5rem;
    vertical-align: middle;
    text-align: center;
    font-size: large;
  }

  .equity_align_right {
    vertical-align: middle;
    text-align: right;
  }
  .equity_align_right_heavy {
    vertical-align: middle;
    text-align: right;
    font-weight: bold;
  }
  .equity_align_left {
    vertical-align: middle;
    text-align: left;
  }

  a.disabled {
    pointer-events: none;
  }

  .price-data {
    vertical-align: middle;
    text-align: end;
    display: table-cell;
  }

  .clickable_item {
    cursor:  pointer;
  }
.dot_money {
    height: 10px;
    width: 10px;
    background-color: #189e18;
    border-radius: 50%;
    display: inline-block;
}
.dot_instruments {
    height: 10px;
    width: 10px;
    background-color: #008FFB;
    border-radius: 50%;
    display: inline-block;
}

  .ion-md-close-circle {
    cursor: pointer;
  }

  .ion-ios-refresh {
    cursor: pointer;
  }

  .table-responsive {
    overflow: auto;
    max-height: 45rem;
  }

  .card-img-top {
      width: 100%;
      height: 4vw;
      object-fit: scale-down;
  }

  .card-img-top-responsive {
      width: 100%;
      height: 15vw;
      object-fit: scale-down;
  }  

  .trade-confirmed-modal-header {
      border-bottom: 0;
      justify-content: flex-end;
      padding-bottom: 0;
  }

  .show_list_horizontal {
      overflow-x: auto; 
      max-width: 100%; 
      max-height: auto; 
      flex: 1; 
      flex-wrap: nowrap;
  } 
  
.xxsmall-font-size {
    font-size: xx-small;
}

.xsmall-font-size {
    font-size: x-small;
}   
</style>
